import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { interceptors } from '@barracuda/shared-api';
const isExpired = (token) => new Date() > token.expiresAt;
/** Creates an isolated Axios transport and mutable JWT session, following VRM. */
export const makeIDVClientProtocol = (options) => {
    const baseUrl = options.baseUrl.trim();
    let currentToken = null;
    /** Replaces the session JWT. Decode failures throw and preserve the previous session. */
    const setToken = (token) => {
        const { exp } = jwt_decode(token);
        currentToken = { raw: token, expiresAt: new Date(exp * 1000) };
    };
    if (options.token) {
        setToken(options.token);
    }
    const httpProvider = axios.create({ adapter: ['http', 'fetch', 'xhr'] });
    httpProvider.interceptors.request.use((request) => {
        if (!request.headers.has('Authorization') && currentToken && !isExpired(currentToken)) {
            request.headers.set('Authorization', `Bearer ${currentToken.raw}`);
        }
        return request;
    });
    httpProvider.interceptors.response.use((response) => response, (error) => {
        interceptors.sanitizeAuthorizationHeaderFromError(error);
        return Promise.reject(error);
    });
    return {
        httpProvider,
        /** Builds an endpoint URL, throwing before transport when configuration is missing. */
        makeUrl: (path) => {
            if (!baseUrl) {
                throw new Error('IDV service base URL is not configured');
            }
            return `${baseUrl}/${path.replace(/^\/+/, '')}`;
        },
        setToken,
        /** Clears the session for subsequent requests; does not cancel in-flight requests. */
        deleteToken: () => {
            currentToken = null;
        }
    };
};
//# sourceMappingURL=protocol.js.map